
import React, {Component} from 'react';
import {ToastContainer, ToastStore} from 'react-toasts';
import {SERVER_URL}  from '../Constants';



var QRCode = require('qrcode.react');

class PrintLocationLabel extends Component {
  constructor(props) {
    super(props);

    this.state = {
        venueid:-1,
       id:'',
       typeCd:'',
        
    };
  }

  async componentDidMount() {
   



  }
  handleDismiss=()=> {
    this.setState({ showAlert: false });
  }
  renderToast=()=>{
    return <div>
        
        <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
    </div>
}


 

  render() {
  
    return (

    
        <div style={{margin:'10px'}}>
        
         
          
          <div className='row'>
                <div className='col text-center'>
                  Print or right-click and save this QR Code:  <br/> <br/> <br/> <br/>

                        <QRCode renderAs="jpg" style={{width:'350' ,height:'350'}} value={`${SERVER_URL}/box/` + this.props.match.params.id} />
            
                </div>
               
            </div>
           
      </div>

    )
  }
}

export default PrintLocationLabel;